import auth from "../../middlewares/auth";
export const downloadFileRoute = [
  {
    path: '/downloads',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/download/DownloadList.vue'),
    name: 'download_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/download/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/download/DownloadForm.vue'),
    name: 'download_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/download/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/download/DownloadForm.vue'),
    name: 'download_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];